import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { SetPopupReducerData } from "../../../store/reducer/PopupReducer";
import {
  getAlertListApi,
  setEventRecord,
  UseCaseeventListApi,
} from "../../../api/api";
import { useVisionContext } from "../../ContextAPI/VisionContext";
import { toast } from "react-toastify";

const AlertModal = ({ onClose, onSubmit }) => {
  const [selectedAlerts, setSelectedAlerts] = useState([]);
  console.log("selectedAlerts", selectedAlerts);
  const [alertdata, setAlertData] = useState([]);
  const [useCase, setUseCase] = useState([]);
  const [useCaseId, setUseCaseId] = useState("");
  const [maxPeopleLimit, setMaxPeopleLimit] = useState("");
  const { camera_id } = useSelector(
    (state) => state?.PopupReducer?.modal || {}
  );

  //console.log("camera_id", camera_id);
  const dispatch = useDispatch();

  const { visionData, updateState } = useVisionContext();

  const fetchUseCase = async () => {
    try {
      const data = await UseCaseeventListApi();
      if (data?.data?.status === true) {
        setUseCase(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  const fetchAlert = async () => {
    try {
      const data = await getAlertListApi();
      if (data?.data?.status === true) {
        setAlertData(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  useEffect(() => {
    fetchAlert();
    fetchUseCase();
  }, []);

  const handleCheckboxChange = (id) => {
    setSelectedAlerts((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleSubmit = async () => {
    updateState("alertTypeIds", selectedAlerts);
    updateState("useCaseId", useCaseId); // Optional: if needed
    if (onSubmit) onSubmit({ selectedAlerts, useCaseId });
    try {
      const payload = {
        camera_id: camera_id,
        usecase_id: useCaseId,
        alert_type_ids: selectedAlerts,
      };
      const setAlert = await setEventRecord(payload);
      if (setAlert) {
        toast.success("Alert has been set for the camera");
      } else {
        toast.error("somthing went wrong!!");
      }
    } catch (error) {
      //console.log("error", error);
    }
    handleClose();
  };

  const handleClose = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "",
        showModal: false,
      })
    );
  };

  return (
    <div className="rightModal taskModal">
      <div className="modal-header p-3">
        <h4 className="m-0">Alert</h4>
        <button className="btnClose ms-auto" onClick={handleClose}>
          <IoCloseOutline />
        </button>
      </div>

      <div className="p-4">
        <p className="form-label mb-3">Select Alert Type</p>
        <div className="alert-grid">
          {alertdata.map((label, index) => (
            <label className="checkbox-label" key={index}>
              <input
                type="checkbox"
                checked={selectedAlerts.includes(label?._id)}
                onChange={() => handleCheckboxChange(label?._id)}
              />
              <span>{label.alert_name}</span>
            </label>
          ))}
        </div>

        <label className="form-label mt-4">Use Case</label>
        <select
          name="use_case"
          className="form-select"
          value={useCaseId}
          onChange={(e) => setUseCaseId(e.target.value)}
        >
          <option value="">Select</option>
          {useCase.map((ele) => (
            <option key={ele._id} value={ele._id}>
              {ele.usecase_name}
            </option>
          ))}
        </select>

        {selectedAlerts.includes("686e4a95ab7d4a58aa2e965c") && (
          <>
            <label className="form-label mt-4">Max people limit</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter limit"
              value={maxPeopleLimit}
              onChange={(e) => setMaxPeopleLimit(e.target.value)}
            />
          </>
        )}

        <div className="bottomBtn d-flex justify-content-between mt-4">
          <button className="cancel-btn" onClick={handleClose}>
            Cancel
          </button>
          <button className="submit-btn" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
